<template>
  <v-container fluid fill-height class="white content">
    <div v-if="mode === 1" class="shop-selection">
      <v-btn
        style="height: 100%"
        color="fufuyellow"
        text-color="fufugrey2"
        block
        depressed
        @click="dialog = true"
      >
        <v-layout column>
          <v-icon size="72">mdi-store-search</v-icon>
          <b>店舗検索</b>
        </v-layout>
      </v-btn>
    </div>
    <a class="hidden-setting-link" @click="goSetting" />
    <span class="app-version grey--text caption px-1">
      Ver. {{ appVersion }}
    </span>
    <ShopSelectionDialog
      v-model="dialog"
      :shop="shop"
      @update:shop="updateShop"
    />
    <v-layout justify-center column>
      <v-flex align-self-center>
        <v-layout align-end fill-height>
          <v-img
            :src="`${$publicPath}img/fufu-logo1280.png`"
            :aspect-ratio="1280 / 405"
            width="500"
            contain
          />
        </v-layout>
      </v-flex>
      <v-flex xs1 class="text-center">
        <span class="shop title primary--text">
          <b>{{ shop && shop.name }}</b>
        </span>
      </v-flex>
      <v-layout style="width: 100%">
        <template v-if="mode === 2">
          <v-flex xs4 offset-xs4 class="pr-2">
            <v-btn
              color="fufuyellow"
              text-color="fufugrey2"
              :disabled="!shop"
              x-large
              block
              to="/first"
            >
              予約する
            </v-btn>
          </v-flex>
        </template>
        <v-flex v-else xs4 offset-xs4>
          <v-btn
            color="primary"
            :disabled="!shop"
            x-large
            block
            @click="goNext"
          >
            予約する
          </v-btn>
        </v-flex>
      </v-layout>
    </v-layout>

    <v-snackbar :value="updating"> App更新中 </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { setTimeout } from 'timers'

import ShopSelectionDialog from '@/components/ShopSelectionDialog'
import pkg from '@/../package.json'

export default {
  name: 'ReservationTop',
  components: {
    ShopSelectionDialog,
  },
  props: {
    shop: {
      type: Object,
      default: null,
    },
    mode: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    dialog: false,
    settingCounter: 0,
    timerId: null,
    updating: false,
  }),
  computed: {
    ...mapGetters(['swActivate', 'swUpdated']),
    appVersion() {
      return pkg.version
    },
  },
  watch: {
    swActivate(value) {
      if (value) this.checkUpdate()
    },
    swUpdated(value) {
      if (value) this.updateApp()
    },
  },
  mounted() {
    this.checkUpdate()
    this.updateApp()
  },
  methods: {
    async checkUpdate() {
      console.log('checkUpdate: swActivate =', this.swActivate)
      if (this.swActivate) {
        const registration = await navigator.serviceWorker.getRegistration()
        console.log('registration.update')
        await registration.update()
      }
    },
    updateShop(shop) {
      this.dialog = false
      this.$router.replace({
        path: `/reservation/${shop.id}`,
      })
    },
    goNext() {
      this.$router.replace({
        path: `/reservation/${this.shop.id}/menu`,
      })
    },
    goCampaign() {
      this.$router.replace({
        path: `/reservation/${this.shop.id}/campaign`,
      })
    },
    goSetting(e) {
      // console.log(e)
      if (!this.timerId) {
        this.timerId = setTimeout(() => {
          // console.log('clearTimer', this.settingCounter)
          this.timerId = null
          this.settingCounter = 0
        }, 2000)
      }
      this.settingCounter++
      if (this.settingCounter >= 10) {
        this.$router.replace({
          path: `/setting`,
        })
      }
    },
    async updateApp() {
      console.log('swUpdated =', this.swUpdated)
      if (!this.swUpdated) return
      this.updating = true
      const registration = await navigator.serviceWorker.getRegistration()
      if (registration) {
        await registration.unregister()
        document.location.reload()
      }
      this.updating = false
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  position: relative;
}
.shop-selection {
  position: absolute;
  top: 0;
  right: 0;
  width: 124px;
  height: 124px;
}
.app-version {
  position: absolute;
  right: 0;
  bottom: 0;
}
.hidden-setting-link {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100px;
  height: 100px;
  // background-color: red;
}
</style>
